'use strict';

exports.__esModule = true;
exports.default = warnOnce;
var printed = {};

/* istanbul ignore next */
function warnOnce(message) {
    if (printed[message]) return;
    printed[message] = true;

    if (typeof console !== 'undefined' && console.warn) console.warn(message);
}
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/postcss/lib/warn-once.js
 ** module id = 12
 ** module chunks = 0
 **/